<template>
	<TheBox :title="''" class="box--role" :alignment="'center'">
		<div class="flex flex-grow flex--aligncenter">
			<GroupIcon />
			<span class="box--role__name">{{ role.name }}</span>
		</div>

		<div class="button-panel">
			<RouterLink v-if="showGoToDetail" :to="url" class="el-button el-button--primary is-round" :title="'Gruppe anzeigen'" target="_blank">
				Gruppe anzeigen
			</RouterLink>

			<TheButton v-if="showDelete" type="default" @buttonclick="$emit('delete', role)">
				<el-icon><Delete /></el-icon>Gruppe löschen
			</TheButton>
		</div>
	</TheBox>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import TheBox from '../TheBox.vue';
import { RoleResponse } from '../../types/types';
import GroupIcon from '../../assets/icons/GroupIcon.vue';
import TheButton from '../TheButton.vue';
import { Delete } from '@element-plus/icons-vue';
import { returnFormOptions } from '@/utils/formOptions';

export default defineComponent({
	name: 'BoxRole',
	data() {
		return {};
	},
	components: {
		TheBox,
		GroupIcon,
		TheButton,
		Delete,
	},
	props: {
		role: {
			type: Object,
			required: true,
		},
		showGoToDetail: {
			type: Boolean,
			default: true,
		},
		showDelete: {
			type: Boolean,
			default: true,
		},
	},
	emits: ['delete'],
	computed: {
		url() {
			const userRoleOptions = returnFormOptions('userRole');
			const isUserRole = userRoleOptions.find((option) => option.value.name === this.role.name);

			const routeData = this.$router.resolve({ name: isUserRole ? 'User' : 'Kontakte', query: { gruppe: this.role.name } });
			return routeData.fullPath;
		},
	},
});
</script>

<style lang="scss">
.box--role {
	.flex {
		flex-direction: column;

		svg {
			margin-top: 1rem;
		}

		.box--role__name {
			text-align: center;
			font-size: 1.5rem;
			font-weight: 500;
			margin: 0;
			margin-top: 1rem;
		}
	}

	.button-panel {
		margin-bottom: 0;
	}
}
</style>
